



















































































































































































































import firebase from 'firebase/app'
import { user } from '../mapper'
import Cookie from '../comps/Cookie.vue'

export default
    data: -> 
        user: user
    computed:
        banner_class: ->
            if this.$route.name is 'event' then 'eventbanner'
            else if this.$route.name is 'auth' then 'authbanner'
            else if this.$route.name is 'profile' then 'profilebanner'
            else if this.$route.name is 'about' then 'aboutbanner'
            else 'mainbanner'
        languages: ->
            filtered = {}
            if this.$root.$i18n.locale is 'hu' then filtered.en = this.$languages().en else filtered.hu = this.$languages().hu
            # for code, string of this.$languages()
            #     filtered[code] = string unless code is this.$root.$i18n.locale
            return filtered
    methods:
        goHome: ->
            if this.$route.name is 'events' && typeof this.$root.homeCallback is 'function' then this.$root.homeCallback()
            else if this.$route.name != 'events' then this.$router.push {name: 'events'}
        test: ->
            endpoint = firebase.functions().httpsCallable('test')
            try r = await endpoint()
            catch e then console.log(e)
    components: { Cookie }
